import { render } from "./MailItemList.vue?vue&type=template&id=b9482cce&scoped=true"
import script from "./MailItemList.vue?vue&type=script&lang=js"
export * from "./MailItemList.vue?vue&type=script&lang=js"

import "./MailItemList.vue?vue&type=style&index=0&id=b9482cce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9482cce"]])

export default __exports__